import utils from 'utils'
export default class userModalInstanceCtrl {
    constructor($scope, $uibModalInstance, items1, list, userType, httpRequest, logger, params, deBounceService) {
        $scope.totalItems = params.totalItems
        $scope.isPrivate = Boolean(localStorage.deployType == 2)
        $scope.items = items1
        $scope.items1 = items1
        $scope.searchInfoParam = ''
        $scope.userType = JSON.parse(localStorage.user_info).user.userType

        $scope.cancelListAll = false // 全选默认false
        $scope.isCurrent = false // 分页时搜索为false
        $scope.cancelList = {}
        // 全部授权的机构
        httpRequest
            .get_qryUserInfo({
                userName: $scope.items1.userName,
                accessToken: localStorage.id_token,
            })
            .then((res) => {
                $scope.allRoleList = res.data.value.roleList
                $scope.authorizedArr = []
                angular.forEach($scope.allRoleList, (item, index) => {
                    $scope.authorizedArr.push({ orgId: item.orgId, roleId: item.roleId })
                })
            })
        for (const item of list) {
            if (item.orgId != items1.orgOwnership) {
                $scope.cancelList[item.orgId] = false
            }
        }
        $scope.batchCancelAuth = function () {
            if ($scope.cancelListAll) {
                $scope.cancelAuthority = true
            }
            for (const item of $scope.list) {
                for (const key in $scope.cancelList) {
                    if (item.orgId == key && $scope.cancelList[key]) {
                        // item.sysRoleList[selected] = false
                        // item.selected = false
                        // for (const role of item.sysRoleList) {
                        //     role.selected = false
                        // }
                        item.sysRoleList.forEach((i) => {
                            i.selected = false
                        })
                        item.sysUkeyist.forEach((i) => {
                            i.selected = false
                        })
                        $scope.cancelList[item.orgId] = false
                        $scope.cancelListAll = false
                    }
                }
            }
            return
            for (const key in $scope.cancelList) {
                console.log($scope.cancelList[key])
                if ($scope.cancelList[key]) {
                    list.forEach((i) => {
                        if (key == i.orgId) {
                            i.selected = false
                        }
                    })
                }
            }
        }

        $scope.cancelListChange = (val, name) => {
            $scope.cancelList[name] = val
        }
        $scope.$watch(
            'cancelListAll',
            () => {
                if ($scope.cancelListAll) {
                    for (const key in $scope.cancelList) {
                        $scope.cancelList[key] = true
                    }
                } else {
                    for (const key in $scope.cancelList) {
                        $scope.cancelList[key] = false
                    }
                }
            },
            true
        )
        // 无授权折叠， 授权展开
        list.forEach((i) => {
            let hasSelInroleList = false,
                hasSelInUkeyList = false,
                keyWords = []
            keyWords.push(i.orgName)
            hasSelInroleList = i.sysRoleList.some((item) => {
                keyWords.push(item.roleName)
                return item.selected === true
            })
            hasSelInUkeyList = i.sysUkeyist.some((item) => {
                keyWords.push(item.ukeyName)
                return item.selected === true
            })
            i.isShow = hasSelInroleList || hasSelInUkeyList
            i.keyWords = keyWords
        })
        $scope.list = $.extend([], list)
        // 至少必须选择一个角色 所属机构
        $scope.atLeastList = $scope.list[0]
        $scope.$watch(
            'list',
            () => {
                $scope.list &&
                    $scope.list.forEach((i) => {
                        let count = 0
                        i.sysRoleList.forEach((role) => {
                            if (role.roleType == 2) {
                                if (!role.selected) {
                                    i.isManager = false
                                } else {
                                    i.isManager = true
                                    i.sysUkeyist.forEach((o) => {
                                        o.selected = true
                                    })
                                }
                            }
                            if (role.selected) count++
                        })
                        if (!count)
                            i.sysUkeyist.forEach((o) => {
                                o.selected = false
                            })
                    })
            },
            true
        )
        $scope.ok = function () {
            let roleList = []
            let keyist = []
            let cancelAuthList = []
            // let haveSelfRole = false
            $scope.list.forEach((item) => {
                if (item.sysRoleList && item.sysRoleList.length > 0) {
                    item.sysRoleList.forEach((r) => {
                        if (r.selected) {
                            // if (r.orgId == $scope.items.orgOwnership) haveSelfRole = true
                            roleList.push({
                                orgId: r.orgId,
                                roleId: r.roleId,
                            })
                        }
                    })
                }
                if (item.sysUkeyist && item.sysUkeyist.length > 0) {
                    item.sysUkeyist.forEach((k) => {
                        if (k.selected) {
                            keyist.push(k.ukeyId)
                        } else {
                            cancelAuthList.push(k.ukeyId)
                        }
                    })
                }
            })
            let paramData = JSON.parse(JSON.stringify($scope.items))
            paramData.ukeyIdList = keyist
            paramData.cancelAuthList = cancelAuthList
            // 当前页面的授权与勾选或者取消勾选对比
            if (roleList.length > $scope.currentPageRoleList.length) {
                // 全部授权的与新添加授权的数据 合并
                $scope.filterDifferentVal(roleList, $scope.currentPageRoleList)
                $scope.addRolelist = $scope.authorizedArr.concat($scope.filterResult)
                paramData.roleList = $scope.addRolelist
            } else if (roleList.length == $scope.currentPageRoleList.length) {
                // 需要添加的授权
                const addRole = $scope.filterDifferentVal(roleList, $scope.currentPageRoleList)
                // 需要删除的授权
                const deleteRole = $scope.filterDifferentVal($scope.currentPageRoleList, roleList)
                // 全部授权过滤取消的授权
                const deleteHasRole = $scope.filterDifferentVal($scope.authorizedArr, deleteRole)
                const addRolelist = deleteHasRole.concat(addRole)
                paramData.roleList = addRolelist
            } else {
                // 批量取消授权 只保留所属机构的角色权限
                if ($scope.cancelAuthority) {
                    paramData.roleList = roleList
                } else {
                    //  获取取消授权的数据
                    const unauthorizedData = $scope.filterDifferentVal($scope.currentPageRoleList, roleList)
                    // 全部授权的与取消授权的数据对比 删除取消授权
                    const authorizedData = $scope.filterDifferentVal($scope.authorizedArr, unauthorizedData)
                    // 新添加授权的数据
                    const newAuthorizedData = $scope.filterDifferentVal(roleList, authorizedData)
                    paramData.roleList = authorizedData.concat(newAuthorizedData.length ? newAuthorizedData : [])
                }
            }
            // 非admin 所有机构至少有一个角色
            if ($scope.userType && paramData.roleList.length == 0) {
                logger.logError('至少必须选择一个角色！')
                return
            }
            //   if (
            //     (userType != 0 &&
            //       $scope.items.orgOwnership == $scope.atLeastList.orgId &&
            //       paramData.roleList.length == 0) ||
            //     (userType == 0 && !haveSelfRole)
            //   ) {
            //     logger.logError('所属机构至少必须选择一个角色！')
            //     return
            //   }
            httpRequest.post_updateUserRoleR(paramData, '赋权信息提交成功').then((res) => {
                $uibModalInstance.close()
            })
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }

        let timeout
        // 搜索
        $scope.$watch(
            'searchInfoParam',
            deBounceService(function (newV, oldV) {
                if (newV !== oldV && newV) {
                    $scope.queryParam.param.orgName = newV
                    $scope.queryInfo($scope.queryParam)
                } else if (!newV && oldV) {
                    delete $scope.queryParam.param.orgName
                    $scope.queryInfo($scope.queryParam)
                }
            }, 350)
        )
        // 分页查询参数
        $scope.queryParam = {
            pageNum: params.pageNum,
            pageSize: 50,
            param: {
                orgIdByInclude: params.orgIdByInclude,
            },
        }
        // 分页请求
        $scope.pageChanged = function () {
            $scope.queryInfo($scope.queryParam)
        }
        // 查询
        $scope.queryInfo = function (postData) {
            utils.loading('正在加载···')
            httpRequest.post_getSysOrganizationInfoList(JSON.stringify(postData)).then((res) => {
                $scope.result = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                $scope.queryParam.pageSize = res.data.value.pageSize
                utils.loaded()
                setDefaultSelect(items1, $scope.result)
                for (const item of $scope.result) {
                    if (item.orgId != items1.orgOwnership) {
                        $scope.cancelList[item.orgId] = false
                    }
                }
                $scope.result.forEach((i) => {
                    // 无授权折叠， 授权展开
                    let hasSelInroleList = false,
                        hasSelInUkeyList = false,
                        keyWords = []
                    keyWords.push(i.orgName)
                    hasSelInroleList = i.sysRoleList.some((item) => {
                        keyWords.push(item.roleName)
                        return item.selected === true
                    })
                    hasSelInUkeyList = i.sysUkeyist.some((item) => {
                        keyWords.push(item.ukeyName)
                        return item.selected === true
                    })
                    i.isShow = hasSelInroleList || hasSelInUkeyList
                    i.keyWords = keyWords
                })
                $scope.list = $.extend([], $scope.result)
                $scope.queryCurrentPageRoleList($scope.list)
            })
        }
        function setDefaultSelect(data, result) {
            if (!result) return
            result.forEach((item) => {
                // 遍历的item
                if (item.sysRoleList && item.sysRoleList.length > 0) {
                    item.sysRoleList.forEach((r) => {
                        r.selected = false
                        if (data.roleList && data.roleList.length) {
                            for (var i = 0; i < data.roleList.length; i++) {
                                if (data.roleList[i].roleId == r.roleId && data.roleList[i].orgId == r.orgId) {
                                    r.selected = true
                                    break
                                }
                            }
                        }
                    })
                }
                if (item.sysUkeyist && item.sysUkeyist.length > 0) {
                    item.sysUkeyist.forEach((k) => {
                        k.selected = false
                        if (data.ukeyList && data.ukeyList.length) {
                            for (var u = 0; u < data.ukeyList.length; u++) {
                                if (data.ukeyList[u].ukeyId == k.ukeyId) {
                                    k.selected = true
                                    break
                                }
                            }
                        }
                    })
                }
            })
        }
        // 获取当前页的授权机构
        $scope.queryCurrentPageRoleList = function (list) {
            $scope.currentPageRoleList = []
            list.forEach((item) => {
                if (item.sysRoleList && item.sysRoleList.length > 0) {
                    item.sysRoleList.forEach((r) => {
                        if (r.selected) {
                            $scope.currentPageRoleList.push({
                                orgId: r.orgId,
                                roleId: r.roleId,
                            })
                        }
                    })
                }
            })
        }
        $scope.queryCurrentPageRoleList($scope.list)
        // 过滤相同的数据 返回新增授权或者取消授权的数据
        $scope.filterDifferentVal = function (moreListArr, lessListArr) {
            $scope.filterResult = []
            for (var i = 0; i < moreListArr.length; i++) {
                var obj = moreListArr[i]
                var orgId = obj.orgId
                var roleId = obj.roleId
                var isExist = false
                for (var j = 0; j < lessListArr.length; j++) {
                    var cj = lessListArr[j]
                    var cOrgId = cj.orgId
                    var cOleId = cj.roleId
                    if (cOrgId == orgId && cOleId == roleId) {
                        isExist = true
                        break
                    }
                }
                if (!isExist) {
                    $scope.filterResult.push(obj)
                }
            }
            return $scope.filterResult
        }
    }
}
userModalInstanceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'list', 'userType', 'httpRequest', 'logger', 'params', 'deBounceService']



// WEBPACK FOOTER //
// ./src/app/system/permission/user/userModalInstanceCtrl.js